/* eslint-disable no-undef */
import React from 'react';
import * as history from 'history';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';

import './assets/scss/main.scss';
import 'react-toastify/dist/ReactToastify.css';

import { persistor, store } from './redux/store';

import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;

// Test for pipeline running

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter history={history.createBrowserHistory()}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GoogleOAuthProvider clientId={googleClientId}>
          <App />
        </GoogleOAuthProvider>
        <ToastContainer />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
